import ApplyConversationActionContext from 'owa-mail-store/lib/store/schema/ApplyConversationActionContext';
import ApplyConversationActionRequest from 'owa-service/lib/contract/ApplyConversationActionRequest';
import ApplyConversationActionResponseMessage from 'owa-service/lib/contract/ApplyConversationActionResponseMessage';
import applyConversationActionOperation from 'owa-service/lib/operation/applyConversationActionOperation';
import applyConversationActionRequest from 'owa-service/lib/factory/applyConversationActionRequest';
import conversationAction from 'owa-service/lib/factory/conversationAction';
import RetentionType from 'owa-service/lib/contract/RetentionType';
import itemId from 'owa-service/lib/factory/itemId';
import targetFolderIdFactory from 'owa-service/lib/factory/targetFolderId';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';
import RequestOptions from 'owa-service/lib/RequestOptions';
import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import BaseFolderId from 'owa-service/lib/contract/BaseFolderId';
import distinguishedFolderId from 'owa-service/lib/factory/distinguishedFolderId';
import folderId from 'owa-service/lib/factory/folderId';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';

/**
 * @param conversationContexts the conversation action contexts
 * @param retentionPolicyTagId the new retention policy tag id to be set
 * @param retentionPolicyType the retention policy type - archive or delete
 * @param folderId folder id to which the conversation
 * @param requestOptions the request options
 */
export default function setConversationRetentionPolicy(
    conversationContexts: ApplyConversationActionContext[],
    retentionPolicyTagId: string,
    retentionPolicyType: RetentionType,
    folderId: string,
    requestOptions: RequestOptions
): Promise<ApplyConversationActionResponseMessage> {
    const requestBody = configureRequestBody(
        conversationContexts,
        retentionPolicyTagId,
        retentionPolicyType,
        folderId
    );

    return applyConversationActionOperation(
        {
            Header: getJsonRequestHeader(),
            Body: requestBody,
        },
        requestOptions
    ).then(response => response.Body.ResponseMessages.Items[0]);
}

function createRetentionPolicyConversationAction(
    conversationContext: ApplyConversationActionContext,
    retentionPolicyTagId: string,
    retentionPolicyType: RetentionType,
    folderId: string
) {
    const policyAction = conversationAction({
        Action: 'SetRetentionPolicy',
        ConversationId: itemId({ Id: conversationContext.conversationId }),
        RetentionPolicyType: retentionPolicyType,
    });

    if (retentionPolicyTagId) {
        policyAction.RetentionPolicyTagId = retentionPolicyTagId;
    }
    // folderId can be null in search mode.
    if (folderId) {
        const targetFolderId = targetFolderIdFactory({
            BaseFolderId: createFolderId(folderId),
        });

        policyAction.ContextFolderId = targetFolderId;
    }

    return policyAction;
}

function configureRequestBody(
    conversationContexts: ApplyConversationActionContext[],
    retentionPolicyTagId: string,
    retentionPolicyType: RetentionType,
    folderId: string
): ApplyConversationActionRequest {
    const conversationActions = conversationContexts.map(conversationContext =>
        createRetentionPolicyConversationAction(
            conversationContext,
            retentionPolicyTagId,
            retentionPolicyType,
            folderId
        )
    );
    return applyConversationActionRequest({
        ConversationActions: conversationActions,
        ReturnMovedItemIds: false,
    });
}

function createFolderId(folderIdOrName: string): BaseFolderId {
    return folderNameToId(folderIdOrName)
        ? distinguishedFolderId({ Id: folderIdOrName as DistinguishedFolderIdName })
        : folderId({ Id: folderIdOrName });
}
